export function getWeekend(from: Date): [Date, Date] {
  let begin = new Date(from);

  let dayOfWeek = 5; //friday
  let diff = begin.getDay() - dayOfWeek;

  if (diff > 0) {
    begin.setDate(begin.getDate() + 6);
  } else if (diff < 0) {
    begin.setDate(begin.getDate() - diff);
  }

  let end = new Date(begin);
  end.setDate(begin.getDate() + 2);

  return [begin, end];
}
